import * as React from 'react';

import gql from 'graphql-tag';

import { StyleSheet, color, css } from '@coursera/coursera-ui';
import { SvgCheckSolid, SvgCircleWarning, SvgClockFilled } from '@coursera/coursera-ui/svg';

import type { ComputedOutcome, ComputedProgress } from 'bundles/degree-home/types/Course';
import { isGradedItemOutcome } from 'bundles/degree-home/types/Course';
import ProgressCircle from 'bundles/ui/components/ProgressCircle';

import _t from 'i18n!nls/degree-home';

type Props = {
  isOverdue: boolean;
  computedProgress: ComputedProgress;
  computedOutcome?: ComputedOutcome;
};

const styles = StyleSheet.create({
  inReview: {
    color: color.secondaryText,
  },
});

class ProgressIcon extends React.Component<Props> {
  static fragment = gql`
    fragment ProgressIconFragment on DegreeLearnerProgressesV1_org_coursera_degree_learner_ItemState {
      computedProgress {
        progressState
      }
      computedOutcome {
        ... on DegreeLearnerProgressesV1_org_coursera_degree_learner_OutcomeMember {
          org_coursera_degree_learner_Outcome {
            grade
            isPassed
          }
        }
        ... on DegreeLearnerProgressesV1_org_coursera_degree_learner_NotGradedItemOutcomeMember {
          org_coursera_degree_learner_NotGradedItemOutcome {
            computedAt
          }
        }
      }
    }
  `;

  render() {
    const { isOverdue, computedProgress, computedOutcome } = this.props;

    if (
      computedProgress.progressState === 'Completed' &&
      computedOutcome &&
      computedOutcome.org_coursera_degree_learner_Outcome &&
      isGradedItemOutcome(computedOutcome.org_coursera_degree_learner_Outcome) &&
      computedOutcome.org_coursera_degree_learner_Outcome.isPassed
    ) {
      return <SvgCheckSolid fill={color.success} size={18} />;
    } else if (computedProgress.progressState === 'InReview') {
      return <i {...css(styles.inReview)}>{_t('In review')}</i>;
    } else if (computedProgress.progressState === 'Failed') {
      return <SvgCircleWarning fill={color.error} size={18} />;
    } else if (computedProgress.progressState === 'Optional') {
      return <i {...css(styles.inReview)}>{_t('Optional')}</i>;
    } else if (isOverdue) {
      return <SvgClockFilled fill={color.warning} size={18} />;
    } else {
      return <ProgressCircle percentComplete={0} innerColor="#fafafa" backgroundColor="#ddd" />;
    }
  }
}

export default ProgressIcon;
